var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngleDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99993 12.362C9.62079 12.362 9.27612 12.2241 9.00038 11.9484L0.383553 2.98686C-0.133457 2.43538 -0.133457 1.5737 0.41802 1.02223C0.969497 0.505215 1.83118 0.505215 2.38266 1.05669L9.99993 8.98417L17.6172 1.05669C18.1342 0.505215 19.0304 0.505215 19.5818 1.02223C20.1333 1.53923 20.1333 2.43538 19.6163 2.98686L10.9995 11.9484C10.7237 12.2241 10.3791 12.362 9.99993 12.362Z",
    fill: "#44C2F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleDown);
export default __webpack_public_path__ + "static/media/angle-down.b47d44f97d493c9e9525bd6eb66573ab.svg";
export { ForwardRef as ReactComponent };